/*
 *		Copyright (c) 2011-2019 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accNodeNotarizationCertificate', ['ENV', '$window', function(ENV, $window) {
        return {
            scope: {
                notarization: '=accNodeNotarizationCertificate'
            },
            link: function($scope, $element) {
                $element.on('click', function() {
                    var
                        certificateUrl = ENV['cloudPlatformNotaryPath'] + '/certificate/' + $scope.notarization['notary_certificate_id'];

                    $window.open(certificateUrl, '_blank');
                })
            }
        };
   }]
);
